/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
import { RoleListEntryFromJSON, RoleListEntryToJSON, } from './RoleListEntry';
/**
 * Check if a given object implements the PagedResponseOfRoleListEntry interface.
 */
export function instanceOfPagedResponseOfRoleListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfRoleListEntryFromJSON(json) {
    return PagedResponseOfRoleListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfRoleListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(RoleListEntryFromJSON)),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage'])
    };
}
export function PagedResponseOfRoleListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'previousPage': PageRequestToJSON(value.previousPage),
        'hasNext': value.hasNext,
        'numberOfElements': value.numberOfElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(RoleListEntryToJSON)),
        'hasPrevious': value.hasPrevious,
        'size': value.size,
        'page': value.page,
        'totalElements': value.totalElements,
        'metaData': MetaDataToJSON(value.metaData),
        'nextPage': PageRequestToJSON(value.nextPage)
    };
}
